import { Box, BoxProps, Stack, Divider } from "@mui/material"

import { Loading } from 'components/controls/loading'
import { ErrorBlock } from 'components/controls/errorInfo'

import { TrialResult } from "interface/trial"

import { SisetuPreviewDialog } from 'features/sisetu/dialog/preview'
import { KojinPreviewDialog } from 'features/kojin/dialog/preview'

import { useTrialPreview } from './container'
import { TrialPreviewHeader } from './components/header'
import { TrialPreviewBody } from './components/body'
import { TrialPreviewFooter } from './components/footer'

type TrialPreviewProps = {
  trialList?: TrialResult[]
  trialId?: number | null
	trial?: TrialResult | null
  targetSisetuCode?: string
  targetKojinCode?: string
	onSisetuOpenReply?: (sisetuCode: string | null) => void
  onKojinOpenReply?: (kojinCode: string | null) => void
  onClose?: () => void
} & BoxProps
export const TrialPreview = ({
  trialList,
  trialId: defaultTrialId,
  trial: defaultTrial,
  targetSisetuCode,
  targetKojinCode,
  onSisetuOpenReply,
  onKojinOpenReply,
  onClose,
  ...others
}: TrialPreviewProps) => {
  const container = useTrialPreview({
    trialList,
    defaultTrial,
    defaultTrialId,
    targetSisetuCode,
    targetKojinCode,
    onSisetuOpenReply,
    onKojinOpenReply,
    onClose
  })
  const {
    loading, error, trial,
    /*onSisetuOpen,*/ selectedSisetuCode, sisetuList,
    /*onKojinOpen,*/ selectedKojinCode, kojinList,
    closeModal
  } = container

  return (
    <>
      <Box {...others}>
        {loading && <Loading/>}
        <ErrorBlock error={error}/>

        {trial && (
          <Stack direction="column" sx={{ height: '100%', boxSizing: 'border-box' }}>
            <TrialPreviewHeader trial={trial} container={container}/>
            <Divider/>
            <TrialPreviewBody trial={trial} container={container} flexGrow={1} boxSizing='border-box' overflow='auto'/>
            <Divider/>
            <TrialPreviewFooter trial={trial} container={container}/>
          </Stack>
        )}
      </Box>

      {selectedSisetuCode ? (
        <SisetuPreviewDialog
          sisetuList={sisetuList}
          sisetuCode={selectedSisetuCode}
          onClose={closeModal}
        />
      ) : selectedKojinCode ? (
        <KojinPreviewDialog
          kojinList={kojinList}
          kojinCode={selectedKojinCode}
          onClose={closeModal}
        />
      ) : <></>}
    </>
  )
}
